import { Box } from '@apia/theme';
import { useFieldSelector } from '../../../../store/validation/validationStore';
import { useFormContext } from '../FormContext';

/**
 * Renderiza los errores del campo con el nombre pasado
 * como prop. En caso de que no exista error, no renderiza
 * nada.
 *
 * @props
 * *name:* El nombre del campo cuyos errores se quieren
 * renderizar.
 */
const ValidationError = ({ name }: { name: string }) => {
  const formContext = useFormContext();
  const error = useFieldSelector(formContext.name, name, (state) => {
    return state?.error;
  });

  return error ? (
    <Box
      as="strong"
      role="alert"
      sx={{
        color: 'danger',
      }}
      dangerouslySetInnerHTML={{ __html: error }}
    />
  ) : null;
};

export default ValidationError;
